import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { SessionService } from "src/app/services/session.service";
import { environment } from "src/environments/environment";
import * as $ from "jquery";


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  
  username: string;

  constructor(
    private httpClient: HttpClient,
    private sess: SessionService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService
  ) {}

  ngOnInit(): void {
    
  }

 btnMobilemenu(){
    $(".mobile-menu").toggle();
  }


  btnMobilemenu_2(){
    $(".mobile-menu-custom").slideToggle(300);
  }




}
